module.exports = __webpack_public_path__ + "img/expovina-primavera_05.b62f4937.jpg";